import { clearTokens, getRefreshToken } from "@/lib/api";
import { SignOut } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLogout } from "@/services/mutations/auth";
import { useIsMutating } from "@tanstack/react-query";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Mixpanel } from "@/lib/mixpanel";
const LogoutButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // Offline edits sit in the mutation cache until they reach the server; logout drops them.
  const unsentEdits = useIsMutating();
  const { mutate: logout } = useLogout({
    onSuccess: async () => {
      await clearTokens();
      navigate("/login");
      Mixpanel.track("Logout Successfully");
    },
    onError: () => {
      Mixpanel.track("Logout Failed");
    },
  });

  return (
    <Dialog>
      <DialogTrigger data-testid="logout-button" asChild>
        <button className="flex w-full flex-row items-center gap-2 px-5 py-[15px]">
          <SignOut size={24} color="white" />
          <span className="font-base font-medium text-white">
            {t("button.logout")}
          </span>
        </button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader className="hidden">
          <DialogTitle>{t("label.logout")}</DialogTitle>
        </DialogHeader>

        <div className="mb-2 mt-4 flex flex-col gap-4">
          <p className="text-white">{t("label.logout_confirmation")}</p>
          {unsentEdits > 0 && (
            <p
              className="text-sm text-amber-400"
              data-testid="unsent-edits-warning"
            >
              {t("label.logout_unsent_edits", { count: unsentEdits })}
            </p>
          )}
        </div>

        <DialogFooter className="flex flex-row justify-end gap-2">
          <DialogClose asChild>
            <Button variant="outline">{t("button.cancel")}</Button>
          </DialogClose>
          <Button
            onClick={() => logout({ refreshToken: getRefreshToken() ?? "" })}
          >
            {t("button.logout")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LogoutButton;
